const driversView = {
  bindings: {
    settings: '<',
    view: '<',
    gridlet: '<',
  },
  templateUrl: '/modules/gridlets/drivers-view/drivers-view.html',
  controller: 'DriversViewController',
};

angular
  .module('gridlets.module')
  .component('driversView', driversView);